import React, { Fragment, useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import HeroForm from '@components/unauthenticated/components/HeroForm';
import HeroContainer from '@components/unauthenticated/components/HeroContainer';

export default function DeletedAccount() {
  const { t } = useTranslation();

  return (
    <HeroContainer>
      <HeroForm xs={12} sm={8} md={6} lg={4}>
        <Box p={2} display="flex" flexDirection="column" flexGrow={1}>
          <Fragment>
            <Box textAlign="start">
              <Typography variant="h4">{t('DeletedAccount.title')}</Typography>
              <hr />
              <br />
              <Typography variant="body2">{t('DeletedAccount.line1')}</Typography>
              <br />
              <Typography variant="body2">{t('DeletedAccount.line2')}</Typography>
            </Box>
            <br />
          </Fragment>
        </Box>
      </HeroForm>
    </HeroContainer>
  );
}
